<template>
    <Dialog v-model:visible="exportModal" modal position="top" :draggable="false" header="Xuất File" :style="{ width: '40rem' }">
        <div class="flex flex-column gap-3">
            <div class="flex flex-column gap-2">
                <label for="">Bản ghi</label>
                <InputNumber v-model="filterExport.PageSize"></InputNumber>
            </div>
            <!-- <div class="flex flex-column gap-2">
                <label for="">Trạng thái</label>
                <Dropdown placeholder="Tất cả" v-model="filterExport.status" :options="StatusFilterOpts" optionLabel="label" optionValue="value"></Dropdown>
            </div> -->
            <div class="flex flex-column gap-2">
                <label for="">Mảng kinh doanh</label>
                <Dropdown placeholder="Tất cả" v-model="filterExport.itemGroupId" :options="itemGroupIdFilterOpts" optionLabel="label" optionValue="value"></Dropdown>
            </div>
            <div class="flex flex-column gap-2">
                <label for="">Hình thức thanh toán</label>
                <MultiSelect v-model="filterExport.paymentMethod" optionLabel="label" placeholder="Tất cả" optionValue="value" :options="paymentMedOpts" :maxSelectedLabels="3" class="w-full" />
            </div>
            <!-- <div class="flex flex-column gap-2">
                <label for="">Cửa hàng</label>
                <Dropdown v-model="filterExport.branchId" placeholder="Chọn cửa hàng" class="w-full" :options="optionsBranch" optionLabel="branchName" optionValue="id"></Dropdown>
            </div>
            <div class="flex flex-column gap-2">
                <label for="">Quầy</label>
                <Dropdown v-model="filterExport.counterId" placeholder="Quầy hàng" :options="[]" optionValue="id" optionLabel="name" class="w-full mb-2"></Dropdown>
            </div> -->
            <div class="flex gap-2">
                <div class="flex flex-column gap-2 w-full">
                    <label for="">Từ</label>
                    <Calendar field v-model="filterExport.fromDate" showIcon :maxDate="filterExport.toDate" iconDisplay="input"></Calendar>
                </div>
                <div class="flex flex-column gap-2 w-full">
                    <label for="">Đến</label>
                    <Calendar v-model="filterExport.toDate" field showIcon :minDate="filterExport.fromDate" iconDisplay="input"></Calendar>
                </div>
            </div>
        </div>

        <template #footer>
            <div class="flex justify-end gap-2">
                <Button type="button" label="Hủy" severity="secondary" @click="exportModal = false"></Button>
                <Button type="button" label="Xuất file" icon="pi pi-file-export" @click="ExportData()"></Button>
            </div>
        </template>
    </Dialog>
    <Dialog v-model:visible="progressingModal" modal header="Xuất File" :style="{ width: '50rem' }">
        <ProgressBar :value="progressing"></ProgressBar>
        <div class="text-center">
            <span>Đang xuất dữ liệu...</span>
        </div>
    </Dialog>
    <Loading v-if="loading"></Loading>
</template>
<script setup>
import { onMounted, reactive, ref, watch } from 'vue';
import ExcelJS from 'exceljs';
import _ from 'lodash';
import { format } from 'date-fns';
import API from '../../../api/api-main';
import { getCurrentInstance } from 'vue';
import { useToast } from 'primevue/usetoast';
const { proxy } = getCurrentInstance();
const props = defineProps(['totalRecords']);

const toast = useToast();
const API_URL = ref('InventoryReport');
const filterExport = reactive({
    PageSize: props.totalRecords,
    status: '',
    fromDate: null,
    toDate: null,
    branchId: null,
    counterId: null,
    paymentMethod: '',
    itemGroupId: ''
});
watch(
    () => props.totalRecords,
    (newValue) => {
        filterExport.PageSize = newValue;
    }
);
const itemGroupIdFilterOpts = ref([
    {
        label: 'Vàng trao đổi',
        value: 'docType=GoldExchange'
    },
    {
        label: 'Vàng trang sức',
        value: 'docType=GoldJewelry'
    },
    {
        label: 'Đặt hàng',
        value: 'objType=26'
    },
    {
        label: 'Bán hàng',
        value: 'objType=13'
    },
    {
        label: 'Tất cả',
        value: ''
    }
]);
const paymentMedOpts = ref([
    {
        label: 'Tiền mặt',
        value: 'Cash'
    },
    {
        label: 'Chuyển khoản',
        value: 'BankWire'
    },
    {
        label: 'Thẻ',
        value: 'BankCard'
    },
    {
        label: 'Trả trước',
        value: 'Prepaid'
    },
    {
        // Tiền khách trả bằng voucher — khác với cột "Voucher" giảm giá (distcountAmountVoucher).
        label: 'Voucher (thanh toán)',
        value: 'Voucher'
    }
]);
const exportModal = defineModel();
const progressingModal = ref(false);
const dataToExport = ref([]);
const progressing = ref(0);

const ExportData = async (data = '') => {
    let pageSize = filterExport.PageSize;
    let totalPages = Math.ceil(pageSize / 1000);
    pageSize = Math.min(pageSize, 1000);
    if (totalPages > 0) {
        for (let i = 0; i < totalPages; i++) {
            let url = `${API_URL.value}/getHd?Page=${i + 1}&PageSize=${pageSize}`;
            let query = getExportFilter();
            if (query) {
                url += `&Filter=${query}`;
            }
            try {
                progressingModal.value = true;
                const res = await API.get(url);
                progressing.value = Math.ceil(((i + 1) / totalPages) * 100);
                if (data) {
                    dataToExport.value = [data];
                } else {
                    dataToExport.value.push(...res.data.items);
                }
            } catch (error) {
                console.error('Lỗi khi lấy dữ liệu:', error);
            }
        }
    }
    try {
        if (_.isEmpty(dataToExport.value)) {
            proxy.$notify('E', 'Không dữ liệu để xuất', toast);
            return;
        }
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Hóa đơn');

        // Tiêu đề chính
        const titleRow = worksheet.addRow(['HÓA ĐƠN BÁN HÀNG']);
        titleRow.font = { name: 'Arial', size: 16, bold: true };
        worksheet.mergeCells('A1:M1');

        // Tiêu đề phụ
        const subTitleRow = worksheet.addRow(['Thông tin hóa đơn', '', '', '', 'Thông tin khách hàng', '', '', '', '', '', 'Thông tin hàng hóa', '', '', '', '', '', '', '', '', 'Thông tin thanh toán']);
        worksheet.mergeCells('A2:D2');
        worksheet.getCell('A2').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '83CCEB' }
        };
        worksheet.mergeCells('E2:J2');
        worksheet.getCell('E2').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'D9D9D9' }
        };
        worksheet.mergeCells('K2:S2');
        worksheet.getCell('K2').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '61CBF3' }
        };
        worksheet.mergeCells('T2:AD2');
        worksheet.getCell('T2').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'B5E6A2' }
        };
        subTitleRow.font = { name: 'Times New Roman', size: 11, bold: true };
        subTitleRow.alignment = { horizontal: 'center', vertical: 'middle' };
        worksheet.getRow(subTitleRow.number).height = 30;

        // Định dạng cột
        worksheet.getColumn('A').width = 25;
        worksheet.getColumn('B').width = 25;
        worksheet.getColumn('C').width = 30;
        worksheet.getColumn('D').width = 35;
        worksheet.getColumn('E').width = 25;
        worksheet.getColumn('F').width = 50;
        worksheet.getColumn('G').width = 75;
        worksheet.getColumn('H').width = 20;
        worksheet.getColumn('I').width = 25;
        worksheet.getColumn('J').width = 15;
        worksheet.getColumn('K').width = 20;
        worksheet.getColumn('L').width = 40;
        worksheet.getColumn('M').width = 25;
        worksheet.getColumn('N').width = 10;
        worksheet.getColumn('O').width = 20;
        worksheet.getColumn('P').width = 25;
        worksheet.getColumn('P').numFmt = '""#,##0';
        worksheet.getColumn('Q').width = 50;
        worksheet.getColumn('Q').numFmt = '""#,##0';
        worksheet.getColumn('R').width = 50;
        worksheet.getColumn('S').width = 50;
        worksheet.getColumn('T').width = 50;
        worksheet.getColumn('U').width = 40;
        worksheet.getColumn('V').width = 40;
        worksheet.getColumn('V').numFmt = '""#,##0';
        worksheet.getColumn('W').width = 40;
        worksheet.getColumn('W').numFmt = '""#,##0';
        worksheet.getColumn('X').width = 40;
        worksheet.getColumn('X').numFmt = '""#,##0';
        worksheet.getColumn('Y').width = 40;
        worksheet.getColumn('Y').numFmt = '""#,##0';
        worksheet.getColumn('Z').width = 40;
        worksheet.getColumn('Z').numFmt = '""#,##0';
        worksheet.getColumn('AA').width = 40;
        worksheet.getColumn('AB').width = 40;
        worksheet.getColumn('AC').width = 40;
        worksheet.getColumn('AD').width = 40;
        worksheet.getColumn('AE').width = 40;

        // Tiêu đề cột
        const headerRow = worksheet.addRow([
            'Số hóa đơn (*)',
            'Thời gian (*)',
            'NV bán hàng',
            'Kênh bán',
            'Mã khách hàng',
            'Tên khách hàng',
            'Địa chỉ',
            'Điện thoại',
            'Căn cước công dân',
            'Giới tính',
            'Mã SKU (*)',
            'Mã vạch (*)',
            'Đơn vị tính',
            'Số lượng',
            'Trọng lượng',
            'Đơn giá',
            'Thành tiền',
            'Giảm giá hàng hóa',
            'Ghi chú hàng hóa',
            'Giảm giá hóa đơn',
            'Ghi chú hóa đơn',
            '',
            '',
            '',
            '',
            '', // Dành chỗ cho 5 hình thức thanh toán
            'Số tài khoản',
            'Số HDĐT',
            'Trạng thái',
            'Quầy hàng',
            'Cửa hàng'
        ]);

        // Merge và định dạng tiêu đề
        ['A3', 'B3', 'C3', 'D3', 'E3', 'F3', 'G3', 'H3', 'I3', 'J3', 'K3', 'L3', 'M3', 'N3', 'O3', 'P3', 'Q3', 'R3', 'S3', 'T3', 'U3', 'AA3', 'AB3', 'AC3', 'AD3', 'AE3'].forEach((cell) => worksheet.mergeCells(`${cell}:${cell.replace('3', '4')}`));
        worksheet.mergeCells('V3:Z3');
        worksheet.getCell('V3').value = 'Hình thức thanh toán (*)';

        // Gán giá trị cho các hình thức thanh toán.
        // "Voucher (thanh toán)" là TIỀN khách trả bằng voucher — đừng nhầm với cột
        // "Voucher" giảm giá khuyến mại (distcountAmountVoucher) nằm ngoài nhóm này.
        worksheet.getCell('V4').value = 'Tiền mặt';
        worksheet.getCell('W4').value = 'Chuyển khoản';
        worksheet.getCell('X4').value = 'Thẻ';
        worksheet.getCell('Y4').value = 'Urbox';
        worksheet.getCell('Z4').value = 'Voucher (thanh toán)';
        worksheet.getRow(4).font = { name: 'Times New Roman', size: 11, bold: true };
        worksheet.getRow(4).alignment = { horizontal: 'center', vertical: 'middle' };

        headerRow.font = { name: 'Times New Roman', size: 11, bold: true };
        headerRow.alignment = { horizontal: 'center', vertical: 'middle' };
        worksheet.getRow(headerRow.number).height = 30;

        // Định dạng màu nền và viền
        const ranges = ['A3', 'B3', 'C3', 'D3'];
        ranges.forEach((range) => {
            worksheet.getCell(range).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'E49EDD' }
            };
            worksheet.getCell(range).border = {
                top: { style: 'thin', color: { argb: '000000' } },
                left: { style: 'thin', color: { argb: '000000' } },
                bottom: { style: 'thin', color: { argb: '000000' } },
                right: { style: 'thin', color: { argb: '000000' } }
            };
        });

        const ranges2 = ['E3', 'F3', 'G3', 'H3', 'I3', 'J3'];
        ranges2.forEach((range) => {
            worksheet.getCell(range).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'D9D9D9' }
            };
            worksheet.getCell(range).border = {
                top: { style: 'thin', color: { argb: '000000' } },
                left: { style: 'thin', color: { argb: '000000' } },
                bottom: { style: 'thin', color: { argb: '000000' } },
                right: { style: 'thin', color: { argb: '000000' } }
            };
        });

        const ranges3 = ['K3', 'L3', 'M3', 'N3', 'O3', 'P3', 'Q3', 'R3', 'S3'];
        ranges3.forEach((range) => {
            worksheet.getCell(range).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '61CBF3' }
            };
            worksheet.getCell(range).border = {
                top: { style: 'thin', color: { argb: '000000' } },
                left: { style: 'thin', color: { argb: '000000' } },
                bottom: { style: 'thin', color: { argb: '000000' } },
                right: { style: 'thin', color: { argb: '000000' } }
            };
        });

        const ranges4 = ['T3', 'U3', 'V3', 'AA3', 'AB3', 'AC3', 'AD3', 'AE3'];
        ranges4.forEach((range) => {
            worksheet.getCell(range).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'B5E6A2' }
            };
            worksheet.getCell(range).border = {
                top: { style: 'thin', color: { argb: '000000' } },
                left: { style: 'thin', color: { argb: '000000' } },
                bottom: { style: 'thin', color: { argb: '000000' } },
                right: { style: 'thin', color: { argb: '000000' } }
            };
        });

        const httt = ['V4', 'W4', 'X4', 'Y4', 'Z4'];
        httt.forEach((el) => {
            worksheet.getCell(el).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'B5E6A2' }
            };
            worksheet.getCell(el).border = {
                top: { style: 'thin', color: { argb: '000000' } },
                left: { style: 'thin', color: { argb: '000000' } },
                bottom: { style: 'thin', color: { argb: '000000' } },
                right: { style: 'thin', color: { argb: '000000' } }
            };
        });

        // Thêm dữ liệu
        _.forEach(dataToExport.value, (item) => {
            if (item.itemDetail && item.itemDetail.length > 0) {
                let totalLineTotal = 0;
                item.itemDetail.forEach((detail, index) => {
                    totalLineTotal += detail.lineTotal;
                    if (index === 0) {
                        const paymentMethods = item.paymentMethod?.reduce((acc, el) => {
                            acc[el.paymentMethodCode] = el.amount;
                            return acc;
                        }, {});
                        const row = worksheet.addRow([
                            item.invoiceCode,
                            format(item.docDate, 'HH:mm dd/MM/yyyy'),
                            item.creator,
                            item.counter?.name,
                            item.cardCode,
                            item.cardName,
                            null,
                            item?.address?.phone,
                            item?.citizenId,
                            item?.gender === 'M' ? `Nam` : `Nữ`,
                            detail.itemCode,
                            detail.itemName,
                            detail?.ougp?.ugpName,
                            detail.quantity,
                            detail.weightGold * detail.quantity,
                            detail.price,
                            totalLineTotal,
                            null,
                            detail.note,
                            null,
                            item.note,
                            item.paymentMethod?.length > 0 ? paymentMethods.Cash : null,
                            item.paymentMethod?.length > 0 ? paymentMethods.BankWire : null,
                            item.paymentMethod?.length > 0 ? paymentMethods.Card : null,
                            item.paymentMethod?.length > 0 ? paymentMethods.Urbox : null,
                            item.paymentMethod?.length > 0 ? paymentMethods.Voucher : null,
                            paymentMethods?.bankCardCode || null,
                            item.linkInvoice,
                            formatStatus(item.status, item),
                            item.counter?.name,
                            item.branch?.branchName
                        ]);
                        row.font = { name: 'Times New Roman', size: 11 };
                        worksheet.getCell(`J${row.number}`).alignment = { wrapText: true };
                    } else {
                        const row = worksheet.addRow([
                            item.invoiceCode,
                            format(item.docDate, 'HH:mm dd/MM/yyyy'),
                            item.creator,
                            item.counter?.name,
                            item.cardCode,
                            item.cardName,
                            null,
                            item?.address?.phone,
                            item?.citizenId,
                            item?.gender === 'M' ? `Nam` : `Nữ`,
                            detail.itemCode,
                            detail.itemName,
                            detail?.ougp?.ugpName,
                            detail.quantity,
                            detail.weightGold * detail.quantity,
                            detail.price,
                            detail.lineTotal,
                            '',
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            '',
                            item.linkInvoice,
                            formatStatus(item.status, item),
                            item.counter?.name,
                            item.branch?.branchName
                        ]);
                        row.font = { name: 'Times New Roman', size: 11 };
                        worksheet.getCell(`J${row.number}`).alignment = { wrapText: true };
                    }
                });
            } else {
                const row = worksheet.addRow([
                    item.invoiceCode,
                    format(item.docDate, 'HH:mm dd/MM/yyyy'),
                    item.creator,
                    item.counter.name,
                    item.cardCode,
                    item.cardName,
                    `${item.address.locationName}, ${item.address.areaName}, ${item.address.cityName}`,
                    item?.address?.phone,
                    item?.citizenId,
                    item?.gender === 'M' ? `Nam` : `Nữ`,
                    item?.itemDetail.map((el) => el.itemCode).join(', '),
                    item?.itemDetail.map((el) => el.itemName).join(', '),
                    item.itemDetail?.ougp?.ugpName,
                    item.itemDetail?.map((el) => el.quantity).join(', '),
                    item.itemDetail?.reduce((total, el) => total + el.quantity * el.weightGold, 0),
                    item.itemDetail.reduce((total, el) => total + el.price, 0),
                    item.itemDetail.reduce((total, el) => total + el.lineTotal, 0),
                    null,
                    null,
                    null,
                    null,
                    item.paymentMethod.map((el) => el.paymentMethodName).join(', '),
                    item.paymentMethod.map((el) => el.bankCardCode).join(''),
                    item.linkInvoice,
                    formatStatus(item.status, item),
                    item.counter?.name,
                    item.branch?.branchName
                ]);
                row.font = { name: 'Arial', size: 12 };
                worksheet.getCell(`J${row.number}`).alignment = { wrapText: true };
            }
        });

        // Xuất file
        const now = new Date();
        const fileName = `DS_Hóa_đơn_${now.getDate()}-${now.getMonth() + 1}-${now.getFullYear()}_${now.getHours()}-${now.getMinutes()}.xlsx`;
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/octet-stream' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();

        proxy.$notify('S', 'Xuất file thành công', toast);
    } catch (error) {
        console.log(error);
    } finally {
        progressing.value = 0;
        progressingModal.value = false;
    }
};
const getExportFilter = () => {
    let queryArr = [];
    if (filterExport.status) {
        queryArr.push(`status=${filterExport.status}`);
    }
    if (filterExport.fromDate && filterExport.toDate) {
        queryArr.push(`docDate<=${format(filterExport.toDate, 'yyyy-MM-dd')} 23:59:59.999,docDate>${format(filterExport.fromDate, 'yyyy-MM-dd')} 00:00`);
    }
    if (filterExport.paymentMethod?.length > 0) {
        let str = filterExport.paymentMethod.map((el) => `paymentMethod.paymentMethodCode=${el}`).join('|');
        queryArr.push(str);
    }
    if (filterExport.branchId) {
        queryArr.push(`branchId=${filterExport.branchId}`);
    }
    if (filterExport.counterId) {
        queryArr.push(`counterId=${filterExport.counterId}`);
    }
    if (filterExport.itemGroupId) {
        queryArr.push(`${filterExport.itemGroupId}`);
    }
    let queryStr = queryArr.length > 1 ? queryArr.join(',') : queryArr.join('');
    return queryStr;
};

const formatStatus = (status, data) => {
    if (data.canceled) {
        return 'Hủy';
    }
    if (data.canceledInvoice && !data.isIssue) {
        return 'Huỷ thanh toán';
    }
    if (data.canceledIssue && !data.canceledInvoice) {
        return 'Huỷ lần 1';
    }
    if (data.isIssue && data.canceledInvoice) {
        return 'Huỷ lần 2';
    }
    if (status == 'O') {
        return 'Chờ thanh toán';
    }
    if (status == 'CP' && data.isIssue) {
        return 'Đã trả vàng';
    }
    if (status == 'CP' && data.isEInvoice) {
        return 'Đã thanh toán';
    }
};
</script>
<style >
</style>